import React, { useEffect } from 'react';
import {
    Box,
    Heading,
    Text,
    VStack,
    useToast,
} from '@chakra-ui/react';
import Navbar from '../../../components/Navbar';
import { FilterOdooVsSakti } from '../components/FilterOdooVsSakti';
import { OdooVsSaktiTable } from '../components/OdooVsSaktiTable';
import { useOdooVsSakti } from '../hooks/useOdooVsSakti';
import type { OdooVsSaktiFilters } from '../types';

export const OdooVsSaktiPage: React.FC = () => {
    const { groupedData, loading, error, fetchData } = useOdooVsSakti();
    const toast = useToast();

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (error) {
            toast({
                title: 'Error',
                description: error,
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: 'top-right',
            });
        }
    }, [error, toast]);

    const handleFiltersChange = (filters: OdooVsSaktiFilters) => {
        fetchData(filters);
    };

    return (
        <Box minH="100vh" bg="gray.50">
            <Navbar />

            <Box flex="1" p={{ base: 4, md: 6 }}>
                <VStack spacing={6} align="stretch">
                    <VStack align="start" spacing={1}>
                        <Heading size="lg" color="gray.700" mb={2}>
                            Odoo vs Sakti
                        </Heading>
                        <Text color="gray.600" fontSize="sm">
                            Perbandingan data panen BKM (Odoo) dengan aplikasi Sakti
                        </Text>
                    </VStack>

                    <FilterOdooVsSakti
                        onFiltersChange={handleFiltersChange}
                        isLoading={loading}
                    />

                    <OdooVsSaktiTable
                        groupedData={groupedData}
                        loading={loading}
                        error={error}
                    />
                </VStack>
            </Box>
        </Box>
    );
};
